import { OfferDto } from 'types/dtos'
import { OfferModel } from 'types/models'

import { transformCurrencyAmountDtoOrString } from './currency-amount'

export const transformOfferDto = ({ id, price, currency }: OfferDto): OfferModel => ({
  id,
  price: transformCurrencyAmountDtoOrString(price, currency),
})
